import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import FilterPanel from '../components/FilterPanel';
import NewIn from '../components/NewIn';
import OurPicks from '../components/OurPicks';
import Quickies from '../components/Quickies';
import { fetchAllRecipes } from '../components/api';
import Banner from '../components/banner/Banner';
import { auth } from '../components/firebase';
import '../styling/homePage.css';
import MealsOfTheDay from './MealsOfTheDay';

function Home() {
  const [userName, setUserName] = useState('');
  const [user] = useAuthState(auth);
  const [page, setPage] = useState('all'); // 'all', 'saved', or 'myRecipes'
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    portionSize: '',
    cuisine: '',
    highProtein: false,
    budgetFriendly: false,
    vegan: 'all',
    maxCalories: '',
    difficulty: '',
    prepTime: ''
  });

  const [cuisineOptions, setCuisineOptions] = useState([]);

  useEffect(() => {
    // fetch recipes to derive cuisine options for the home filter select
    fetchAllRecipes().then((list) => {
      const cuisines = Array.from(new Set(list.map(r => (r.cuisine || '').toString().trim()).filter(Boolean)));
      setCuisineOptions(cuisines.sort());
    }).catch(() => {});
  }, []);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFilters({
      portionSize: '',
      cuisine: '',
      highProtein: false,
      budgetFriendly: false,
      vegan: 'all',
      maxCalories: '',
      difficulty: '',
      prepTime: ''
    });
  };

  const handleSearch = (currentFilters) => {
    // build query string with only set filters
    const params = new URLSearchParams();
    Object.keys(currentFilters).forEach((k) => {
      const v = currentFilters[k];
      // skip empty values
      if (v === null || v === undefined || v === '') return;
      // skip empty arrays
      if (Array.isArray(v) && v.length === 0) return;
      // skip vegan default
      if (k === 'vegan' && v === 'all') return;
      // skip highProtein when false
      if (k === 'highProtein' && (v === false || v === 'false')) return;
      // skip budgetFriendly when false
      if (k === 'budgetFriendly' && (v === false || v === 'false')) return;

      // handle arrays (like difficulty) by joining with commas
      if (Array.isArray(v)) {
        params.set(k, v.join(','));
      } else {
        params.set(k, v);
      }
    });
    navigate(`/search?${params.toString()}`);
  };

  useEffect(() => {
    if (user) {
      setUserName(user.displayName);
    } else {
      setUserName('');
    }
  }, [user]);

  return (
    <div className="container_">
      <Banner />
      <br />
      <div className="recpies_main_wrapper">
        {/* On the home page we only show the filters and a Search button */}
        <FilterPanel
          filters={filters}
          onChange={handleFilterChange}
          onClear={handleClear}
          showSearchButton={true}
          onSearch={handleSearch}
          cuisineOptions={cuisineOptions}
        />
      </div>
      <br></br>
      
      <OurPicks />
      
      <Quickies />
      
      <NewIn />
      
      {/* meals of the day */}
      {/* MealsOfTheDay component to be added here in the future */}
      <MealsOfTheDay />
  
    </div>
  );
}

// Function to calculate line position based on the active page
function getPagePosition(activePage) {
  switch (activePage) {
    case 'all':
      return '0%';
    case 'saved':
      return '33.333%'; // Adjust this based on the number of buttons
    case 'myRecipes':
      return '66.666%'; // Adjust this based on the number of buttons
    default:
      return '0%';
  }
}

export default Home;
